import React, { useState, useEffect, useRef } from 'react'
import styled, { css } from 'styled-components'
import { navigate } from 'gatsby'
import { Link, Button } from '@raysync/common/components'
import { multiLineTextEllipsis, Media } from '@raysync/common/theme'
import { Navigation } from '@raysync/common/services'
import { EmptyContent } from '../../components'
import { SearchService } from '../../service'
import { useMedia } from '@raysync/common/hooks'
const SearchContainer = styled.div`
  width: 500px;
  display: flex;
  justify-content: center;
  position: relative;
  box-shadow: 0px 2px 10px 0px rgba(99, 103, 114, 0.1);
  border-radius: 25px;
  margin-top: 20px;
  button {
    width: 100px;
    height: 50px;
    border-radius: 0px 25px 25px 0px;
  }
  ${Media.phone`
    width: 6rem;
    margin: .34rem auto;
    border-radius: .6rem;
    button {
      width: 1.2rem;
      height: .6rem;
    }
  `}
`

const Input = styled.input`
  width: 400px;
  height: 50px;
  padding: 10px 10px 10px 26px;
  border: none;
  border-radius: 4px;
  background: #ffffff;
  border-radius: 25px 0px 0px 25px;
  outline: none;
  ${Media.phone`
    width: 4.8rem;
    height: .6rem;
    padding-left: .32rem;
  `}
`

const Dropdown = styled.div`
  position: absolute;
  background: white;
  top: 52px;
  width: 500px;
  padding: 0 20px;
  overflow-y: auto;
  z-index: 1000;
  transition: opacity 1.5s ease;
  border-radius: 5px;
  display: none;
  opacity: 0;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
  ${p =>
    p.show &&
    css`
      display: block;
      opacity: 1;
    `}
  ${Media.phone`
    top: .64rem;
    width: 6rem;
    padding: 0 .3rem;
  `}
`

const PostItem = styled.div`
  display: flex;
  padding: 14px 0;
  border-bottom: 1px solid #d8d8d8;
  cursor: pointer;
  h4 {
    font-size: 18px;
    min-width: 120px;
    font-weight: bold;
    line-height: 1.2;
  }
  > div {
    span {
      color: ${p => p.theme.color.secondary};
    }
    h5 {
      font-size: 16px;
      line-height: 1.2;
      font-weight: bold;
      margin-bottom: 4px;
      span {
        font-size: 16px;
        font-weight: bold;
      }
    }
    p {
      color: #636772;
      font-size: 14px;
      line-height: 1.5;
      span {
        font-size: 14px;
      }
      ${multiLineTextEllipsis(2)};
    }
  }
  ${Media.phone`
    padding: .2rem 0 ;
    h4 {
      font-size: .3rem;
      min-width: 1.6rem;
    }
    > div{
      h5 {
        font-size: .3rem;
        span {
          font-size: .3rem;
        }
      }
      p {
        font-size: .24rem;
        span {
          font-size: .24rem;
        }
      }
    }
  `}
`
const MoreButton = styled(Link)`
  color: ${p => p.theme.color.secondary};
  font-size: 16px;
  padding: 16px 0;
  display: block;
  ${Media.phone`
    font-size: .24rem;
    padding: .2rem 0;
  `}
`
export function SearchInput(props) {
  const [inputValue, setInputValue] = useState('')
  const [showOptions, setShowOptions] = useState(false)
  const [results, setResults] = useState([])
  const ref = useRef(null)
  const isMobile = useMedia()
  const showLength = isMobile ? 3 : 5
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowOptions(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref])
  const handleSearch = (keyword = inputValue) => {
    if (keyword) {
      console.log(keyword)
      const res = SearchService.search(keyword).slice(0, showLength)
      setShowOptions(true)
      setResults(res)
    } else {
      setShowOptions(false)
    }
  }
  const navigateToSearchPage = (value = inputValue) => {
    if (!value) return
    navigate(`/support/search?keyword=${value}`)
  }

  return (
    <SearchContainer ref={ref}>
      <Input
        value={inputValue}
        placeholder='请输入搜索关键词'
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.stopPropagation()
            handleSearch()
          }
        }}
        onFocus={() => {
          handleSearch()
        }}
        onChange={e => {
          const keyword = e.target.value
          setInputValue(keyword)
          handleSearch(keyword)
        }}
      />
      <Button
        onClick={() => {
          navigateToSearchPage()
        }}
      >
        搜索
      </Button>
      <Dropdown show={showOptions}>
        {results && results.length > 0 ? (
          <>
            {results.map((post, index) => (
              <PostItem
                key={index}
                onClick={() => {
                  Navigation.to({ link: post.url })
                }}
              >
                <h4>{post.primaryTitle}</h4>
                <div>
                  <h5 dangerouslySetInnerHTML={{ __html: post.highlightTitle }}></h5>
                  <p dangerouslySetInnerHTML={{ __html: post.highlightContent }}></p>
                </div>
              </PostItem>
            ))}
            <MoreButton to={`/support/search?keyword=${inputValue}`}>查看更多结果 &gt;</MoreButton>
          </>
        ) : (
          <EmptyContent />
        )}
        {}
      </Dropdown>
    </SearchContainer>
  )
}
